import { defineMessages } from 'utils/intl';

export default defineMessages({
  clientsAboutUs: 'Klienci o nas',
  recommended: 'Polecane przez {appShortName}',
  configuratorProcess: 'Proces realizacji zamówienia',
});
